module.exports = {
    model: {
        tabs: [],
    },

    events: {
        focusTab: {
            type: 'click',
            selector: '.base_tabStrip_tab',
            action: event => {
                const self = event.data.component
                const $target = $(event.target).closest('.base_tabStrip_tab')
                if($target.length > 0) {
                    const registerSecret = $target.data('registerSecret')
                    if(registerSecret !== undefined){
                        self.closest('base_tabStrip_tabStrip', tabStrip => {
                            tabStrip.focusTab(registerSecret)
                            self.closest('base_popover_popover', popover => {
                                popover.hide(true)
                            })
                        })
                    }
                }
            }
        },

        hoverChangePrevention: {
            type: 'mousewheel DOMMouseScroll',
            action: function(event){
                event.stopImmediatePropagation();
            }
        }
    },

    hooks: {
        onShow($element, options){
            this.model.tabs = []
            this.closest('templates_core_tabStrip_tabStrip', tabStrip => {
                for(const registerSecret in tabStrip.registry || {}){
                    const element = tabStrip.registry[registerSecret];
                    if(element.tab){
                        const isMainTab = ((element.tab || {}).config || {}).isMainTab || false
                        const html = element.tab.render()
                        const $html = $(html)
                        const additionalClasses = []
                        if(isMainTab){
                            additionalClasses.push('isMainTab')
                        }

                        $html
                            .removeAttr('id')
                            .removeAttr('data-component-index')
                            .attr('data-register-secret', registerSecret)
                            .addClass(additionalClasses.join(' '))
                        $html.find('button[data-field-type="close"]').remove()
                        this.model.tabs.push($html[0].outerHTML)
                    }
                }
            })
            this.refresh(false)

            this.closest('base_popover_popover', popover => {
                popover.refreshDimensions()
            })
        },
    }
}